import React from "react";
import PropTypes from "prop-types";
import {
  compose,
  setPropTypes,
  withState,
  withProps,
  mapProps,
} from "recompose";
import makeCommandDispatcher from "web/core/apollo/makeCommandDispatcher";
import { FormattedMessage } from "react-intl";
import { trackRegisterSubmit } from "../../../components/helpers/AnalyticsV4/TrackAnlyticsV4";
import { withShop } from "web/core/shop/ShopContext";

const EnhanceRegisterForm = ({ LoginMutation, RegisterMutation }) =>
  compose(
    setPropTypes({
      onLoginSuccess: PropTypes.func.isRequired,
    }),
    withState("canSubmit", "setCanSubmit", false),
    withState("pending", "setPending", false),
    withState("errorMessage", "setErrorMessage", null),
    withShop(),
    withProps((props) => ({
      hasError: !!props.errorMessage,
      onSuccess: () => {
        props.onLoginSuccess();
      },
      onError: (data) => {
        if (
          process.env.NODE_ENV === "development" &&
          data.errorMessage !==
            "A customer with the same email already exists in an associated website."
        ) {
          console.warn(
            "The error message in the response is different from the default case."
          );
        }
        props.setErrorMessage(
          <FormattedMessage
            id="modules.User.RegisterForm.registerError"
            defaultMessage="A customer with the same email already exists in an associated website."
          />
        );
      },
    })),
    makeCommandDispatcher({
      authenticateUser:
        (props) =>
        ({ email, password }) => {
          return {
            options: {
              mutation: LoginMutation,
              refetchQueries: ["User", "Cart", "CartQty"],
              variables: {
                username: email,
                password: password,
              },
            },
          };
        },
    }),
    mapProps(({ onSuccess, ...props }) => props),
    makeCommandDispatcher({
      register: (props) => (user) => {
        props.setPending(true);
        props.setErrorMessage(null);
        return {
          options: {
            mutation: RegisterMutation,
            refetchQueries: ["User"],
            variables: {
              customer: {
                email: user.email,
                title: user.title,
                firstname: user.firstname,
                lastname: user.lastname,
                password: user.password,
                is_subscribed_to_newsletter: user.is_subscribed_to_newsletter,
              },
            },
          },
          callback: ({ status, data }) => {
            if (status === "success" && data.success) {
              props.authenticateUser(user);
              trackRegisterSubmit(props.shop);
            } else {
              console.error(data);
              props.setPending(false);
              props.setErrorMessage(data.errorMessage);
            }
          },
        };
      },
    })
  );

export default EnhanceRegisterForm;
